import { render } from "./Tenis.vue?vue&type=template&id=5bc8c9b7&scoped=true"
import script from "./Tenis.vue?vue&type=script&lang=js"
export * from "./Tenis.vue?vue&type=script&lang=js"

import "./Tenis.vue?vue&type=style&index=0&id=5bc8c9b7&scoped=true&lang=css"
import "./Tenis.vue?vue&type=style&index=1&id=5bc8c9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc8c9b7"]])

export default __exports__